import { useMutation } from "react-query";
import httpClient from "utils/http-client";
import { API_RESEND_EMAIL } from "consts";

export default function useResendEmail(config) {
  return useMutation((data) => httpClient.post(API_RESEND_EMAIL, data), config);
}
